
import {Component} from "vue-property-decorator";
import WorldCupComponent from "@/libs/WorldCupComponent";
import {mapState} from "vuex";
import Deferrable from "@/libs/common/delegate/Deferrable";
import {Duct} from "@/libs/Duct";
import Defer from "@/libs/Defer";
import StageInterface from "@/libs/model/StageInterface";
import BackToTop from "@/components/BackToTop.vue";
@Component({
  components: {
    BackToTop,
  },
  computed: {
    ...mapState({
      pointsTable: "pointsTable",
    }),
  },
})
export default class PointsTable
  extends WorldCupComponent
  implements Deferrable
{
  config: any;
  pointsTable: any;
  isPreloaded: boolean;
  isMounted: boolean;
  defer: Defer;

  getStageData(): Array<StageInterface> {
    let data = this.getStoreData(this.pointsTable);

    if (!data) {
      return [];
    }

    if (!data.stage) {
      return [];
    }
    return data.stage;
  }

  get lastUpdated(): String {
    let data = this.getStoreData(this.pointsTable);
    if (!data) {
      return "--:--";
    }

    let lastUpdated = data.lastUpdated;
    if(!lastUpdated){
      return "--:--";
    }

    let datetime = new Date(lastUpdated);
    let dateFormat = new Intl.DateTimeFormat('en-US', {month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric'});
    return dateFormat.format(datetime).replace("at", "").replace("AM", "am").replace("PM","pm");
  }

  get backToTopButton(): boolean {
    return this.getOption().pointsTable.backToTopButton;
  }

  created() {
    Duct.open(Duct.Vanes.OnPreloadDone, this.onPreloadDone);

    this.defer = Defer.create().setDeferrable(this);
    this.defer.wait();
  }

  mounted() {
    this.isMounted = true;
    this.onDebug(this, "PointsTable:mounted", {});
  }

  onDefer() {
    if (this.isPreloaded && this.isMounted) {
      return false;
    }
    return true;
  }

  onReady() {
    $( ".pt-slide-right" ).each(function() {
      $(this).on('click', function() {
        var container = $(this).parents('div').next('.table-wrapper').find('.table-container')[0];
        sideScroll(container, 'right', 25, 100, 10);
      });
    });

    $( ".pt-slide-left" ).each(function() {
      $(this).on('click', function() {
        var container = $(this).parents('div').next('.table-wrapper').find('.table-container')[0];
        sideScroll(container, 'left', 100, 50, 10);
      });
    });

    function sideScroll(element, direction, speed, distance, step) {
      var scrollAmount = 0;
      var slideTimer = setInterval(function () {
        if (direction == 'left') {
          element.scrollLeft -= step * 2;
        } else {
          element.scrollLeft += step * 1;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    }
    
  }

  onPreloadDone() {
    this.isPreloaded = true;
  }

}
